import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M79.0975 44.7123C79.0975 44.7123 60.4175 34.4622 56.3675 29.7322C51.8675 24.4722 52.0675 1.83228 52.0675 1.83228H39.6475C39.6475 1.83228 39.9575 24.5822 35.3475 29.7322C30.4575 35.1922 12.3975 44.0522 12.3975 44.0522C18.5875 58.6322 36.3275 68.3323 45.8675 68.3323C55.4075 68.3323 72.9075 59.2923 79.0975 44.7123Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.3972 58.9522C85.5972 47.9522 83.0672 45.6622 77.9472 42.4522C77.8072 42.3722 63.8472 34.4822 63.8472 34.4822L45.7372 60.0822L27.4572 34.4822C27.4572 34.4822 13.5972 42.3922 13.4372 42.4922C8.08723 45.8722 5.60722 48.3222 4.07722 58.9522C2.44722 70.3122 2.15723 72.0222 2.15723 72.0222H89.3072C89.3172 72.0222 89.0772 69.1522 87.3972 58.9522Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M70.5468 38.3623C70.5468 38.3623 69.2268 56.1124 45.7768 61.9724C22.3268 56.1124 21.0068 38.3623 21.0068 38.3623"
        stroke={outline}
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.7442"
          y1="41.0262"
          x2="45.7442"
          y2="15.0297"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
